export const EMAIL_APP_MODULE = '@module/email_preview_app_module';

export const typesApp = {
  PATH: `${EMAIL_APP_MODULE}`,
  mutations: {
    SET_IS_POSTING: '@mutation/setIsPostingEmailPreviewAppModule',
    SET_RECAPTCHA_ID: '@mutation/setRecaptchaIdEmailPreviewAppModule',
  },
  actions: {
    UPDATE_IS_POSTING: '@action/updateIsPostingEmailPreviewAppModule',
    UPDATE_RECAPTCHA_ID: '@action/updateRecaptchaIdEmailPreviewAppModule',
  },
  getters: {
    GET_IS_POSTING: '@getter/getIsPostingEmailPreviewAppModule',
    GET_RECAPTCHA_ID: '@getter/getRecaptchaIdEmailPreviewAppModule',
  },
};
